<template>
  <div class="manage-header">
    <div class="manage-header.logo">
      <!-- <img src="../assets/logo.png" alt=""> -->
      <h3>{{ title }}</h3>
    </div>
    <div class="manage-header.status">
      <!--  -->
      <router-link to="/news">
        <el-badge is-dot class="item" v-if="num !== 0">
          <i class="fa fa-bell-o" style="margin: 0;"></i>
        </el-badge>
        <i v-else class="fa fa-bell-o" style="margin: 0;"></i>
        <span style="margin-left: 10px;">消息</span>
      </router-link>
      <!--  -->
      <a href="javascript:;">
        <i class="el-icon-user-solid"></i>
        {{ name }}
      </a>
      <a href="javascript:;" :class="{ '+is-active-func': isActive }" @click="toggleUser">
        <i class="fa fa-comments"></i>
        用户
      </a>
      <router-link to="/home" v-if="showHome > -1">
        <i class="fa fa-briefcase"></i>
        工作台
      </router-link>
      <span @click="longout">退出</span>
    </div>
    <div class="chat-sidebar" :class="{ '--is-active': isActive }">
      <ul>
        <li v-for="(item, index) in allUser" :key="index">
          <span>
            <img :src="require('../assets/user-' + (index + 1 > 11 ? 8 : index + 1) + '.png')" />
          </span>
          <span>{{ item.username }}</span>
          <i :class="item.online == 1 ? 'online' : 'offline'"></i>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getToken } from '../utils/auth'; // 验权
export default {
  name: 'mHeader',
  props: {
    msg: String
  },
  data() {
    return {
      title: '兰州科技大市场后台',
      num: 0,
      name: '',
      isActive: false,
      showHome: 0,
      allUser: [
        { name: '林良妃', img: require('../assets/user-1.png'), isOnline: true },
        { name: '阿达萨法沙发', img: require('../assets/user-2.png'), isOnline: false },
        { name: '撒法', img: require('../assets/user-3.png'), isOnline: false },
        { name: '啊沙发沙发', img: require('../assets/user-4.png'), isOnline: false },
        { name: '撒法发撒打发', img: require('../assets/user-5.png'), isOnline: false },
        { name: '山豆根山豆根是', img: require('../assets/user-6.png'), isOnline: false },
        { name: '尔特瑞特', img: require('../assets/user-7.png'), isOnline: false },
        { name: '大发噶', img: require('../assets/user-8.png'), isOnline: true },
        { name: '是敢死队风格', img: require('../assets/user-9.png'), isOnline: true }
      ]
    };
  },
  methods: {
    longout() {
      this.$store.dispatch('logout', getToken()).then(res => {
        this.$router.replace('/login');
      });
    },
    toggleUser() {
      this.isActive = !this.isActive;
    }
  },
  watch: {
    $route: {
      handler(newVal) {
        const userInfo = this.$store.getters.userInfo ? JSON.parse(this.$store.getters.userInfo) : {};
        this.name = userInfo.username;
        console.log('localStorage.setItem', localStorage.getItem('showHome'));
        this.showHome = localStorage.getItem('showHome');
        if (userInfo.role_id === 29) {
          this.title = '金昌科技大市场后台';
        }
      }
    },
    '$store.getters.newsNum': {
      handler(newVal) {
        this.num = newVal;
      },
      deep: true
    }
  },
  created() {
    this.http
      .post(`${this.urlConfig.devUrl}apij2/admin-api/system/user/page`, {
        type: 2,
        all: 1
      })
      .then(res => {
        if (res.code == 0) {
          this.allUser = res.data.data;
        }
      })
      .catch(err => {
        this.$message.error(err);
      });
  },
  mounted() {
    this.name = this.$store.getters.userInfo?JSON.parse(this.$store.getters.userInfo).userName:'';
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@include component(manage-header) {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  @include part(logo) {
    height: 80%;
    padding-left: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      display: block;
      height: 100%;
    }
    h3 {
      color: #fff;
      font-weight: 700;
      font-size: 20px;
      margin: 0;
    }
  }
  @include part(status) {
    padding-right: 30px;
    cursor: pointer;
    display: flex;
    height: 100%;
    > a {
      text-decoration: none;
      margin-right: 30px;
      color: #fff;
      display: flex;
      align-items: center;
      padding: 0 15px;
      i {
        font-size: 20px;
        margin-right: 5px;
      }
    }
    > span {
      display: inline-block;
      height: 100%;
      line-height: 70px;
    }
  }
  @include tweak(is-active-func) {
    background: #623aa2;
  }
}
@include component(chat-sidebar) {
  background-color: #f5f5f5;
  border-left: 1px solid #e7e7e7;
  position: fixed;
  right: -300px;
  bottom: 0;
  top: 70px;
  width: 300px;
  height: 100%;
  z-index: 99;
  transition: all 0.5s ease 0s;

  @include option(is-active) {
    right: 0;
  }
  > ul {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    padding-top: 20px;
    padding-left: 10px;
    padding-bottom: 20px;
    li {
      width: 100%;
      height: 60px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;

      > span {
        display: inline-block;
        color: #222;
        &:nth-child(1) {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 10px;
          > img {
            width: 100%;
            display: block;
          }
        }
      }
      > i {
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        position: absolute;
        right: 30px;
        top: calc(52px / 2);
        &.online {
          background: #42b72a;
        }
        &.offline {
          background: #777;
        }
      }
    }
  }
}
</style>
